<template>
  <VaCard>
    <VaCardTitle>
      <h1 class="card-title text-tag text-secondary font-bold uppercase">Vendas da plataforma neste mês</h1>
    </VaCardTitle>
    <VaCardContent>
      <div class="p-1 bg-black rounded absolute right-4 top-4">
        <VaIcon name="mso-attach_money" color="#fff" size="large" />
      </div>
      <section>
        <div class="text-xl font-bold mb-2">
          {{ formatMoney(homeStore.data.orders_total_month) }}
        </div>
        <!--        {{ monthData }}-->
        <!--        {{ homeStore.data.orders_total_month_history }}-->
        <!--        <p class="text-xs text-success">-->
        <!--          <VaIcon name="arrow_upward" />-->
        <!--          25.36%-->
        <!--          <span class="text-secondary"> last month</span>-->
        <!--        </p>-->
      </section>
      <div v-if="monthData" class="w-full flex items-center">
        <VaChart :data="monthData" class="h-24" type="line" :options="options" />
      </div>
    </VaCardContent>
  </VaCard>
</template>

<script setup lang="ts">
import { VaCard, VaCardContent, VaCardTitle, VaIcon } from 'vuestic-ui'
// import { useChartData } from '@/data/charts/composables/useChartData'
import { ChartOptions } from 'chart.js'
import { formatMoney } from '../../../../services/utils'
import { useHomeStore } from '../../../../stores/home'
import { computed } from 'vue'
import VaChart from '../../../../components/va-charts/VaChart.vue'

const homeStore: any = useHomeStore()

const monthData = computed(() => {
  const res = []
  for (let i = 1; i < 13; i++) {
    if (homeStore.data.orders_total_month_history.find((item: any) => item.month === i)) {
      res.push(homeStore.data.orders_total_month_history.find((item: any) => item.month === i).total)
    } else {
      res.push(0)
    }
  }

  return {
    labels: [
      'Janeiro',
      'Fevereiro',
      'Março',
      'Abril',
      'Maio',
      'Junho',
      'Julho',
      'Agosto',
      'Setembro',
      'Outubro',
      'Novembro',
      'Dezembro',
    ],
    datasets: [
      {
        label: 'Faturamento do mês',
        backgroundColor: 'rgba(75,192,192,0.4)',
        data: res,
      },
    ],
  }
})

const options: ChartOptions<'line'> = {
  scales: {
    x: {
      display: false,
      grid: {
        display: false,
      },
    },
    y: {
      display: false,
      grid: {
        display: false,
      },
      ticks: {
        display: false,
      },
    },
  },
  interaction: {
    intersect: false,
    mode: 'index',
  },
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      enabled: true,
    },
  },
}
</script>
